import * as gtm from 'modules/common/lib/gtm/dataLayer'
import { sendAmplitudeData } from '.'
import { EventProps } from '../../types/tracking'

export const trackEvent = ({ eventType, eventProperties }: EventProps) => {
  sendAmplitudeData(eventType, eventProperties)
  gtm.pushEvent(eventType, eventProperties)
}
